import { index } from "./search";

export const getJob = (id: string) =>
  index.getObject(id)
    .then(res => res)
    .catch(err => err)

export async function fetchJob ({ queryKey  }: any) {
  const [, { jobId }] = queryKey

  if(jobId) {
    const response = await getJob(jobId as string);

    if(response.status) {
      throw new Error(response.message)
    }

    if(response.objectID) {
      return response;
    }
  }
}